import { Layout } from 'antd';
import { cn } from '../../../utils/string/cn.utils';

const { Header } = Layout;

const HeaderCMS = ({ children, breadcrumb, actions, ...props }) => {
  return (
    <Header
      {...props}
      className={cn(
        'h-[56px] py-[12px] px-[24px] flex justify-between items-center gap-[16px] self-stretch bg-fills-white shadow-custom overflow-hidden z-100',
        props.className
      )}
    >
      {children ? (
        children
      ) : (
        <>
          <div className="flex items-center min-w-0 flex-shrink">
            {breadcrumb}
          </div>
          <div className="flex items-center min-w-0 flex-shrink max-w-[800px] justify-end">
            {actions}
          </div>
        </>
      )}
    </Header>
  );
};

export default HeaderCMS;
